const initKonintodokePageTop = () => {
  const button = document.querySelector('.konintodoke-page-top-button')

  if (!button) return

  button.addEventListener('click', (event) => {
    event.preventDefault()

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      window.scrollTo(0, 0)
      return
    }

    const startPosition = window.scrollY
    const duration = Math.min(1400, Math.max(300, 300 + startPosition * 0.12))
    let startTime

    const easeOutExpo = (progress) => (
      progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress)
    )

    const scroll = (currentTime) => {
      if (startTime === undefined) startTime = currentTime

      const elapsedTime = currentTime - startTime
      const progress = Math.min(elapsedTime / duration, 1)

      window.scrollTo(0, startPosition * (1 - easeOutExpo(progress)))

      if (progress < 1) window.requestAnimationFrame(scroll)
    }

    window.requestAnimationFrame(scroll)
  })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initKonintodokePageTop)
} else {
  initKonintodokePageTop()
}
